/**
 * Утилиты форматирования для админ-страниц: числа, размеры, даты.
 */

export function fmtBytes(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
    return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

export function fmtNum(n: number): string {
    return n.toLocaleString('ru-RU');
}

export function fmtDate(ms: number | string | null | undefined): string {
    if (ms == null || ms === '') return '—';
    const d = typeof ms === 'string' ? new Date(ms) : new Date(ms);
    if (isNaN(d.getTime())) return String(ms);
    return d.toISOString().replace('T', ' ').slice(0, 19);
}

export function fmtRelative(ms: number | null | undefined): string {
    if (ms == null) return '—';
    const diff = Date.now() - ms;
    if (diff < 0) return 'в будущем';
    const sec = Math.floor(diff / 1000);
    if (sec < 60)   return `${sec} с назад`;
    const min = Math.floor(sec / 60);
    if (min < 60)   return `${min} мин назад`;
    const hour = Math.floor(min / 60);
    if (hour < 24)  return `${hour} ч назад`;
    const day = Math.floor(hour / 24);
    if (day < 30)   return `${day} д назад`;
    const mon = Math.floor(day / 30);
    if (mon < 12)   return `${mon} мес назад`;
    return `${Math.floor(mon / 12)} г назад`;
}

export function fmtUsd(usd: number): string {
    if (usd === 0) return '$0';
    if (usd < 0.01) return `$${usd.toFixed(5)}`;
    if (usd < 1)    return `$${usd.toFixed(4)}`;
    return `$${usd.toFixed(2)}`;
}

export function shortModel(model: string): string {
    if (model.startsWith('mistralai/mistral-small'))  return 'mistral-small';
    if (model.startsWith('anthropic/claude-haiku'))   return 'haiku';
    if (model.startsWith('anthropic/claude-sonnet'))  return 'sonnet';
    if (model.startsWith('anthropic/claude-opus'))    return 'opus';
    if (model.startsWith('google/gemini'))            return model.replace('google/gemini-', 'gemini-');
    if (model.startsWith('openai/'))                  return model.replace('openai/', '');
    if (model.startsWith('qwen/'))                    return model.replace('qwen/', '');
    if (model.startsWith('deepseek/'))                return model.replace('deepseek/', '');
    return model;
}
